import React from 'react';
import { Space } from 'antd';
import Container from '../../components/UI/Container/Container';
import Form from '../../components/Form/Form';
import MainScreen from '../../components/UI/MainScreen/MainScreen';
import ProductList from '../../components/ProductList/ProductList';
import Instruction from '../../components/Instruction/Instruction';

const MainPage = () => {
  return (
    <div style={{ width: '100vw' }}>
      <MainScreen />
      <Container style={{ margin: '60px auto 150px' }}>
        <Space direction='vertical'>
          <ProductList />
        </Space>
        <Instruction />
      </Container>
      <Form />
    </div>
  );
};

export default MainPage;
